import instance from 'api';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IEnableTempEmployee, IResetTempEmployeePassword, ITempEmployee } from './interfaces';

export const getTempEmployeeList = (data: IDynamicTableParams) => {
  return instance()
    .post<ITempEmployee[]>('/admin/user/list', data)
    .then((response) => response.data);
};

export const getTempEmployeeAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/admin/user/availableColumns')
    .then((response) => response.data);
};

export const getTempEmployeeAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/admin/user/availableGroupColumns')
    .then((response) => response.data);
};

export const loadTempEmployee = (username: string) => {
  return instance()
    .get<ITempEmployee>('/admin/user/load/' + username)
    .then((response) => response.data);
};

export const createTempEmployee = (tempEmployee: ITempEmployee) => {
  return instance()
    .post<{ password: string }>('/admin/user/registration', tempEmployee)
    .then((response) => response.data);
};

export const updateTempEmployee = (tempEmployee: ITempEmployee) => {
  return instance()
    .post<void>('/admin/user/update/' + tempEmployee.userId, tempEmployee)
    .then((response) => response.data);
};

export const enableTempEmployee = (tempEmployee: IEnableTempEmployee) => {
  return instance()
    .post<void>('/admin/user/enabled', tempEmployee)
    .then((response) => response.data);
};

export const resetTempEmployeePassword = (tempEmployee: IResetTempEmployeePassword) => {
  return instance()
    .post<{ password: string }>('/admin/user/resetPassword', tempEmployee)
    .then((response) => response.data);
};
